module.exports = __webpack_public_path__ + "img/cla.0e76ac3a.jpg";